import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'
import './question-list.scss'
import { ImageConstants, AccessRights } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import CWConfirm from '../../common/cw-confirmation-modal/cw-confirmation-modal'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import QuestionSetApi from '../../../apis/question-set'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import Loading from '../../common/loading/loading'
import CommonUtils from '../../../utility/common-utilities'
import x64Core from 'crypto-js/x64-core'
class QuestionList extends Component {
  state = {
    meta: {},
    questionSetList: [],
    showQuestions: [],
    questionList: [],
    currentOpenIndex: ''
  }
  currentPage = 1
  limit = 10

  componentDidMount () {
    this.tooltip = this.props.tooltip
    this.getQuestionSet({})
    this.getPracticeQuestionComplexity()
  }

  getPracticeQuestionComplexity = _ => {
    QuestionSetApi.getPracticeQuestionComplexity({})
      .then(response => {
        const complexityList = []
        response.map(res => {
          if (res.title !== 'HOTS') {
            complexityList.push({
              value: res._id,
              title: res.title
            })
          }
        })
        this.setState({
          complexityList
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  showToaster (type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster () {
    this.setState({
      showToaster: false
    })
  }
  setSearchData = payload => {
    this.setState(
      {
        searchText: payload.searchText,
        complexityId: payload.complexityId
      },
      _ => {
        const id = this.state.selectedQuestionSetId
        const index = this.state.currentOpenIndex
        if (id && index >= 0) {
          this.getQuestions(id, index)
        }
      }
    )
  }
  openQuestions = (index, id) => {
    const { showQuestions, questionList, questionSetList } = this.state
    questionSetList.forEach((qs, idx) => {
      if(idx !== index) {
        showQuestions[idx] = false
      }
    })
    showQuestions[index] = showQuestions[index] ? false : true
    this.setState(
      {
        showQuestions,
        currentOpenIndex: index,
        selectedQuestionSetId: id
      },
      _ => {
        // if (
        //   (showQuestions[index] === true && !questionList[index]) ||
        //   questionList[index].length
        // ) {
        //   this.getQuestions(id, index)
        // }
      }
    )
  }

  getQuestions = (id, index) => {
    const { questionList, searchText, complexityId, questionSetList } = this.state
    const payload = {
      id
    }
    if (searchText) payload.searchText = searchText
    if (complexityId) payload.complexityId = complexityId
    QuestionSetApi.getQuestions(payload)
      .then(response => {
        questionSetList[index].questions = response.map(q => {
          return {id: q.id}
        })
        questionList[index] = response
        this.setState({
          questionList,
          questionSetList
        })
      })
      .catch(err => {
        this.showToaster('info', 'Something went wrong')
      })
  }

  showConfirmModal = (item, index) => {
    let deleteMessage = `Are you sure want to delete the question`
    this.setState({
      questionIndex: index,
      deleteItem: item,
      showConfirmModal: true,
      deleteMessage
    }, _ => {
      if (this.tooltip) {
        this.tooltip.tooltipRef = null
        this.tooltip.hideTooltip()
      }
      ReactTooltip.hide()
    })
  }

  hideConfirmModal = _ => {
    this.setState({
      showConfirmModal: false
    })
  }

  deleteQuestion = _ => {
    const { deleteItem, questionIndex, questionSetList } = this.state
    const questionId = deleteItem._id
    const payload = {
      _id: questionId,
      questionSetId: questionSetList[questionIndex]._id
    }
    QuestionSetApi.deleteQuestion(payload)
      .then(response => {
        this.hideConfirmModal()
        // this.getQuestionSet()
        const idx = questionSetList[questionIndex].questionData.findIndex(
          question => question._id === questionId
        )
        if (idx >= 0) {
          questionSetList[questionIndex].questionData.splice(idx, 1)
        }
        this.setState({
          questionSetList
        })
        this.showToaster('info', 'Item deleted successfully')
      })
      .catch(err => {
        this.showToaster('info', 'Something went wrong')
      })
  }

  getQuestionSet (payload) {
    payload.page = payload.page || 1
    payload.limit = this.limit
    payload.class = this.props.className
    this.currentPage = payload.page

    this.setState({ isLoading: true })
    QuestionSetApi.getQuestionSet(payload)
      .then(response => {
        this.setState(
          {
            questionSetList: response.response,
            meta: response.meta || {},
            isLoading: false,
            showList: false,
            questionList: [],
            showQuestions: []
          },
          () => {
            this.setState({ showList: true })
          }
        )
      })
      .catch(err => {
        this.setState({ questionSetList: [], isLoading: false })
      })
  }

  onPageSelected = (selectedPage, startIndex) => {
    this.startIndex = startIndex
    this.currentPage = selectedPage
    this.setState({
      showQuestions: []
    })
    this.props.onPageSelected(selectedPage)
  }

  onEdit = (qsIdx, qIdx) => {
    const { questionSetList, questionList } = this.state
    const chapter = {
      value: questionSetList[qsIdx].chapterKey,
      title: questionSetList[qsIdx].chapterName
    }
    const className = questionSetList[qsIdx].class
    const question = questionSetList[qsIdx].questionData[qIdx]
    this.props.onEdit(chapter, className, question)
  }

  onAddQuestion = qsIdx => {
    const { questionSetList } = this.state
    const chapter = {
      value: questionSetList[qsIdx].chapterKey,
      title: questionSetList[qsIdx].chapterName
    }
    const className = questionSetList[qsIdx].class
    this.props.onOpenAddQuestion(chapter, className)
  }

  getSkillImage = complexityId => {
    const { complexityList } = this.state
    const idx = complexityList.findIndex(c => c.value === complexityId)
    if (idx >= 0) {
      return getImageSource(
        ImageConstants[
          'SKILL_' + complexityList[idx].title.toUpperCase() + '_ICN'
        ]
      )
    } else {
      return getImageSource(
        ImageConstants[
          'SKILL_' + complexityList[0].title.toUpperCase() + '_ICN'
        ]
      )
    }
  }

  getSkillText = complexityId => {
    const { complexityList } = this.state
    const idx = complexityList.findIndex(c => c._id === complexityId)
    if (idx >= 0) {
      return complexityList[idx].title.substr(0, 1)
    } else {
      return complexityList[0].title.substr(0, 1)
    }
  }

  render () {
    const {
      showQuestions,
      meta,
      isLoading,
      questionSetList,
      questionList
    } = this.state
    return (
      <div className='question-bank-list'>
        <div id='table-scoll' className='table-responsive mt-1'>
          <table className='table cw-table bg-white'>
            <tbody>
              {questionSetList?.map((questionSet, index) => (
                <tr key={index} onMouseEnter={ReactTooltip.rebuild}>
                  <td>
                    <div className='question-details'>
                      <div
                        className='chapter-name cursor-pointer'
                        onClick={_ =>
                          this.openQuestions(index, questionSet._id)
                        }
                      >
                        <img
                          className='add-icn chapter-icn'
                          src={
                            questionSet.chapterImage
                              ? questionSet.chapterImage
                              : getImageSource(ImageConstants.CHAPTER_ICN)
                          }
                        />{' '}
                        {questionSet.chapterName}
                      </div>
                      <div className='question-count'>
                        {questionSet.questionData?.length || 0} Questions
                        <img
                          data-tip={"Add Question"}
                          className='add-icn cursor-pointer'
                          src={getImageSource(ImageConstants.ADD)}
                          onClick={_ => this.onAddQuestion(index)}
                        />{' '}
                        <span
                          // data-tip={showQuestions[index] ? "Hide Questions": "Show Questions"}
                          className='accordion-icn cursor-pointer'
                          onClick={_ =>
                            this.openQuestions(index, questionSet._id)
                          }
                        >
                          <FontAwesomeIcon
                            icon={
                              showQuestions[index] ? faAngleUp : faAngleDown
                            }
                          />
                        </span>
                      </div>
                    </div>
                    {showQuestions[index] && (
                      <>
                        {questionSet.questionData?.length > 0 ? (
                          <>
                            {questionSet.questionData.map((question, idx) => (
                              <div
                                className='question-details ques-list'
                                key={idx}
                                onMouseEnter={ReactTooltip.rebuild}
                              >
                                <div
                                  className='question-title'
                                  dangerouslySetInnerHTML={{
                                    __html: question.content.title.replace(
                                      /<(.|\n)*?>/g,
                                      ''
                                    )
                                  }}
                                ></div>
                                <div className='question-actions'>
                                  {question?.mandatoryAttachments?.image && (
                                    <span className='question-score'>
                                      <img
                                        data-tip={"Capture students working"}
                                        className='score-icn'
                                        src={getImageSource(
                                          ImageConstants.CAMERA
                                        )}
                                      />
                                    </span>
                                  )}
                                  <span className='question-score'>
                                    <img
                                      data-tip={"Step"}
                                      className={`score-icn ${
                                        question.content?.isMultiStep
                                          ? 'multi-step'
                                          : ''
                                      }`}
                                      src={getImageSource(
                                        question.content?.isMultiStep
                                          ? ImageConstants.TREE_LINE_ICN_BLACK
                                          : ImageConstants.TREE_LINE_SINGLE_ICN_BLACK
                                      )}
                                    />
                                  </span>
                                  <span className='question-score'>
                                    <img
                                      data-tip={"Complexity"}
                                      className={`score-icn`}
                                      src={getImageSource(ImageConstants["SKILL_" + question.content?.complexity?.toUpperCase() + "_ICN"])}
                                    />
                                    <span>
                                      {question.content.complexity?.substr(0, 1)}
                                    </span>
                                  </span>
                                  <span className='question-score'>
                                    <img
                                      data-tip={"Marks"}
                                      className='score-icn'
                                      src={getImageSource(
                                        ImageConstants.MARK_ICN
                                      )}
                                    />
                                    <span>{question.content.mark}</span>
                                  </span>
                                  <img
                                    data-tip={"Edit"}
                                    className='add-icn action-icn cursor-pointer'
                                    src={getImageSource(ImageConstants.EDIT)}
                                    onClick={_ => this.onEdit(index, idx)}
                                  />
                                  <img
                                    data-tip={"Delete"}
                                    className='add-icn action-icn cursor-pointer'
                                    src={getImageSource(
                                      ImageConstants.DELETE_RED
                                    )}
                                    onClick={_ =>
                                      this.showConfirmModal(question, index)
                                    }
                                  />
                                </div>
                              </div>
                            ))}
                          </>
                        ) : (
                          <div className='text-center p-3'>
                                <div className=''>
                                  <img
                                    className='no-record-image'
                                    src={getImageSource(
                                      ImageConstants.NO_RECORDS
                                    )}
                                  />
                                </div>
                                <div className='pt-2'>
                                  No questions added yet!!
                                </div>
                              </div>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              ))}
              {questionSetList?.length <= 0 && (
                <tr>
                  <td className='text-center'>
                    <div className='p-4'>
                      <strong>No Records Found</strong>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {!isLoading && meta.totalPages !== 0 && (
            <div className=''>
              <PaginationComponent
                startIndex={this.startIndex}
                selectedPage={this.currentPage}
                totalPages={meta.totalPages}
                onPageSelected={this.onPageSelected}
              />
            </div>
          )}
        </div>
        {this.state.showConfirmModal && (
          <CWConfirm
            modal={this.state.showConfirmModal}
            close={this.hideConfirmModal}
            message={this.state.deleteMessage}
            onOk={this.deleteQuestion}
          />
        )}
        {this.state.showToaster ? (
          <div className='custom-toaster-modal'>
            <ToasterComponent
              message={this.state.toasterMessage}
              type={this.state.toasterType}
              position='bottom-center'
            />
          </div>
        ) : (
          ''
        )}
        <ReactTooltip
          ref={el => (this.tooltip = el)}
          multiline={true}
          place='bottom'
          type='dark'
          effect='solid'
          event='mouseover mouseenter'
          eventOff='mouseleave mouseout scroll mousewheel blur'
        />
      </div>
    )
  }
}

export default QuestionList
